// Use to deliver an Evident library in the global scope.
export function expose(key, signature) {
    if (!window.EvidentID) {
        window.EvidentID = {};
    }

    window.EvidentID[key] = signature;
}
